import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import {
	AppSettingsService,
	BreakPointService,
	ButtonComponent,
	CustomWindow,
	DatalayerService,
	FeatureService,
	LocalStorageService,
	NotificationType,
	OliveRoundelComponent,
	OliveService,
	TrackingEvent,
	WINDOW,
} from '@woolworthsnz/styleguide';
import { NgIf } from '@angular/common';

@Component({
	selector: 'wnz-olive-button',
	template: `
		<button
			attr.aria-label="Open Olive chat window"
			(click)="handleChatClick()"
			*ngIf="canShowOlive && !chatWidgetIsActive"
			i18n="@@contactUs-olive-chatnow"
			cdxButton
		>
			Chat now
		</button>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [NgIf, ButtonComponent],
})
export class OliveButtonComponent extends OliveRoundelComponent {
	constructor(
		private datalayerService: DatalayerService,
		@Inject(WINDOW) window: CustomWindow,
		appSettingsService: AppSettingsService,
		breakpointService: BreakPointService,
		localStorageService: LocalStorageService,
		oliveService: OliveService,
		cdr: ChangeDetectorRef,
		featureService: FeatureService
	) {
		super(window, appSettingsService, breakpointService, localStorageService, cdr, featureService, oliveService);
	}

	public handleChatClick(): void {
		this.datalayerService.trackEvent(TrackingEvent.NotificationEvent, NotificationType.Button, 'olive chat now');
		this.showChatWidget();
	}
}
